import React from 'react';
import {
  Form,
  FormLayout,
  TextField,
  TextStyle,
  Button,
  Link
} from '@superops/ui-design-system';

class SignupForm extends React.Component {
  state = {
    firstName: '',
    lastName: '',
    password: '',
    primaryEmail: '',
    companyName: '',
    deviceCount: '',
    priCtryCode: '',
    techCount: ''
  };

  render() {
    const {
      firstName,
      lastName,
      password,
      primaryEmail,
      companyName,
      deviceCount,
      techCount
    } = this.state;

    return (
      <div className="login-box">
        <Form onSubmit={this.handleSubmit}>
          <FormLayout condensed>
            <FormLayout.Group condensed>
              <TextField
                value={firstName}
                onChange={this.handleChange('firstName')}
                label="FIRST NAME"
                type="text"
                placeholder="Dhoni"
                helpText={<span></span>}
              />
              <TextField
                value={lastName}
                onChange={this.handleChange('lastName')}
                label="LAST NAME"
                type="text"
                placeholder="MS"
                helpText={<span></span>}
              />
            </FormLayout.Group>
          </FormLayout>
          <FormLayout>
            <TextField
              value={primaryEmail}
              onChange={this.handleChange('primaryEmail')}
              label="Email"
              type="email"
              placeholder="csk@cubforce.com"
              helpText={<span></span>}
            />
            <TextField
              value={password}
              onChange={this.handleChange('password')}
              label="Password"
              type="password"
              placeholder="**********"
              helpText={<span></span>}
            />
            <TextField
              value={companyName}
              onChange={this.handleChange('companyName')}
              label="COMPANY NAME"
              placeholder="CUBFORCE"
              type="text"
              helpText={<span></span>}
            />
          </FormLayout>

          <FormLayout>
            <FormLayout.Group condensed>
              <TextField
                value={deviceCount}
                onChange={this.handleChange('deviceCount')}
                label="NO OF DEVICE"
                type="text"
                placeholder="101-250"
                helpText={<span></span>}
              />
              <TextField
                value={techCount}
                onChange={this.handleChange('techCount')}
                label="NO OF EMPLOYEE"
                type="text"
                placeholder="1-10"
                helpText={<span></span>}
              />
            </FormLayout.Group>
          </FormLayout>

          <FormLayout>
            <div className="fx actr">
              <div></div>
            </div>

            <div className="fx actr">
              <div>
                <Button primary onClick={this.handleSubmit}>
                  Sign up
                </Button>
              </div>
              <div style={{ marginLeft: 8 }}>
                <TextStyle>Already have account</TextStyle>
                <span style={{ paddingLeft: 4 }}>
                  <Link removeUnderline url="/login">
                    Login here
                  </Link>
                </span>
              </div>
            </div>
          </FormLayout>
        </Form>
      </div>
    );
  }

  handleSubmit = (event) => {
    const {
      firstName,
      lastName,
      primaryEmail,
      companyName,
      phoneNumber,
      priCtryCode,
      deviceCount,
      techCount
    } = this.state;
    this.props.signUpUser({
      variables: {
        firstName,
        lastName,
        primaryEmail,
        companyName,
        phoneNumber,
        priCtryCode,
        deviceCount,
        techCount
      },
      input: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        primaryEmail: this.state.primaryEmail,
        companyName: this.state.companyName,
        phoneNumber: this.state.phoneNumber,
        priCtryCode: this.state.priCtryCode,
        deviceCount: parseInt(this.state.deviceCount),
        techCount: parseInt(this.state.techCount)
      }
    });
  };

  handleChange = (field) => {
    return (value) => this.setState({ [field]: value });
  };
}

export default SignupForm;
